import React from 'react';
import { Chip } from '@mui/material';

const ReusableChip = ({
  label,
  bgcolor ,
  color,
  fontSize = 13,
  sx = {},
  borderRadius,
  ...rest
}) => {
  return (
    <Chip
      label={label}
      sx={{
        bgcolor,
        color,
        fontSize,
        height: 24,
        fontWeight: 500,
        borderRadius: borderRadius,
        ...sx,
      }}
      {...rest}
    />
  );
};

export default ReusableChip;

